<template>
    <nav :class="reactiveClass">
        <button v-if="showMenu" class="burger-menu" @click="toggleMenu"><BurgerIcon/></button>
        <a v-else class="burger-menu" :href="app.basePath">
            <home-icon height="20px"></home-icon>
        </a>
    </nav>
</template>
<script>
import { defineComponent, unref } from 'vue';
import { useAppStore } from '@stores/App';
import BurgerIcon from '@components/Icons/BurgerIcon.vue';
import { useUserStore } from '@stores/User';
import HomeIcon from '@components/Icons/HomeIcon.vue';

export default defineComponent({
    components: { HomeIcon, BurgerIcon },
    computed: {
        reactiveClass() {
            const app = useAppStore();
            return [unref(app.getBreakpoints().active()), 'mobile-nav'];
        },
        showMenu() {
            const user = useUserStore();
            return user.isLoggedIn();
        },
    },
    data() {
        return {
            app: useAppStore(),
        };
    },
    methods: {
        toggleMenu() {
            const app = useAppStore();
            app.burgerMenuOpen = !app.burgerMenuOpen;
        }
    }
});
</script>
<style lang="scss" scoped>

a.burger-menu {
    margin-left: 0.25rem;
}

.burger-menu {
    color: #212121;
    order: -1;
    width: 32px;
    border: none;
    height: 32px;
    display: block;
    padding: 3px;
    grid-row: 1 / 1;
    align-items: center;
    grid-column: 1 / 1;
    margin-left: -6px;
    justify-content: center;
    background-color: transparent;
}

.mobile-nav {
    display: none;
}

.sm,
.md {
    &.mobile-nav {
        display: flex;
        flex-direction: column;
    }
}
</style>
